import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * MarkdownPreview: Renders markdown content with styling
 * Strips to plain text first, then renders as markdown
 */
export const MarkdownPreview = ({ content, maxLength = null, className = '' }) => {
  if (!content) return null;

  // Extract plain text for preview
  const plainText = typeof content === 'string' 
    ? content.replace(/<[^>]*>/g, '').trim()
    : '';

  // Truncate if needed
  const displayText = maxLength && plainText.length > maxLength 
    ? plainText.slice(0, maxLength) + '…'
    : plainText;

  return (
    <div className={`markdown-preview ${className}`}>
      <ReactMarkdown 
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, ...props }) => <p {...props} style={{ margin: '0.5em 0' }} />,
          h1: ({ node, ...props }) => <h1 {...props} style={{ margin: '0.3em 0', fontSize: '1.2em' }} />,
          h2: ({ node, ...props }) => <h2 {...props} style={{ margin: '0.3em 0', fontSize: '1em' }} />,
          h3: ({ node, ...props }) => <h3 {...props} style={{ margin: '0.2em 0', fontSize: '0.95em' }} />,
          ul: ({ node, ...props }) => <ul {...props} style={{ margin: '0.3em 0', paddingLeft: '1.2em' }} />,
          ol: ({ node, ...props }) => <ol {...props} style={{ margin: '0.3em 0', paddingLeft: '1.2em' }} />,
          li: ({ node, ...props }) => <li {...props} style={{ margin: '0.1em 0' }} />,
          strong: ({ node, ...props }) => <strong {...props} style={{ fontWeight: 'bold' }} />,
          em: ({ node, ...props }) => <em {...props} style={{ fontStyle: 'italic' }} />,
          code: ({ node, inline, ...props }) => 
            inline 
              ? <code {...props} style={{ background: '#f0f0f0', padding: '0.2em 0.4em', borderRadius: '2px', fontSize: '0.9em' }} />
              : <code {...props} style={{ background: '#f0f0f0', padding: '0.5em', borderRadius: '3px', display: 'block', overflow: 'auto' }} />,
          blockquote: ({ node, ...props }) => <blockquote {...props} style={{ borderLeft: '3px solid #ccc', paddingLeft: '1em', margin: '0.5em 0', fontStyle: 'italic', opacity: 0.8 }} />,
        }}
      >
        {displayText}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownPreview;
